export default __webpack_public_path__ + "static/media/3.118415a9.jpg";